import { PresentationChartBarIcon, ArrowPathRoundedSquareIcon, ServerIcon } from '@heroicons/react/20/solid'

const features = [
  {
    name: 'Just in time manufacturing.',
    description:
      'Optimize enhances productivity through seamless inventory, sales, and CRM integration.',
    icon: ArrowPathRoundedSquareIcon,
  },
  {
    name: 'Achieve operational excellence.',
    description: 'Real-time production line monitoring empowers informed decision-making.',
    icon: PresentationChartBarIcon,
  },
  {
    name: 'Unified management platform.',
    description: 'By covering all aspects of your value chain, Optimize provides you with a singular source of truth.',
    icon: ServerIcon,
  },
]

export default function Features() {
  return (
    <div id="features" className="overflow-hidden h-screen bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-primary">Build more with less.</h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">A better workflow</p>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                Optimize streamlines manufacturing with an integrated management platform, providing real-time oversight and data-driven insights for a competitive edge.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon className="absolute left-1 top-1 h-5 w-5 text-primary" aria-hidden="true" />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src="/manufacturing-1.jpg"
            alt="Manufacturing"
            className="hidden lg:block w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"

          />
        </div>
      </div>
    </div>
  )
}
